import { connect } from 'react-redux';

import { postIngredient } from '../../actions';

import IngredientEditor from '../components/IngredientEditor';

const mapDispatchToProps = ({
  postIngredient
})

export default connect(
  null,
  mapDispatchToProps
)(IngredientEditor)
